import { createFileRoute } from '@tanstack/react-router'
import { withOrgReset } from '@/components/glitch-ui/with-org-reset'
import { Performance } from '../index'

export const Route = createFileRoute(
  '/_authenticated/_layout/performance/$campaignSlug/',
)({
  component: withOrgReset(Performance),
})
